import { reducers, actions } from './reducers';
import getMetaData from './utility/getMetaData';
import countries from './dicts/countries';
import { getSearchRoute } from './utility/getRoute';
import { getLastSearch } from './utility/searchHistory';
import getCountryChildrenAges from './utility/getCountryChildrenAges';

module.exports = {
  reducer: reducers,
  actions,
  countries,
  getLastSearch,
  getSearchRoute,
  getCountryChildrenAges,
  getMetaData,
  form: require('./RailwaysSearchForm'),
};
